<template>
  <div class="row p-3">
    <div class="col-12 mb-4 ps-0">
      <h5 class="card-title">Bitte beschreiben Sie Ihre Leistung:</h5>
    </div>
    <div class="col-12 col-lg-6">
      <Field as="textarea" name="selbstbeschreibung"
             class="form-input w-100"
             style="min-height:20em"
             v-model="surveyStore.data.selbstbeschreibung"
      />
      <div v-if="errors.selbstbeschreibung" class="invalid-feedback">
        {{ errors.selbstbeschreibung }}
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "../../../stores/survey";
import {Field} from 'vee-validate';

export default {
  components: {
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    errors: Object,
  },
  methods: {},
  computed: {},
}
</script>
